import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PaymentsAPI } from '../services/api';
import { auth } from '../firebase';
import '../styles/PaymentPage.css';

function PaymentPage() {
    const { userProfile, updateUserPlan, user } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('credit_card');

    // CORREÇÃO: Usa o plano pendente do localStorage
    const pendingPlan = localStorage.getItem('pendingPlan') || userProfile?.plan || 'profissional';

    useEffect(() => {
        // Se não há plano pendente e o usuário já está com plano ativo, redireciona
        if (!localStorage.getItem('pendingPlan') && userProfile?.subscriptionStatus === 'active') {
            navigate('/dashboard');
        }

        // Se não há plano pendente e o usuário está no plano básico, redireciona
        if (!localStorage.getItem('pendingPlan') && userProfile?.plan === 'basico') {
            navigate('/dashboard');
        }
    }, [userProfile, navigate]);

    const planDetails = {
        profissional: {
            name: 'Profissional',
            price: 29.90,
            priceDisplay: 'R$ 29,90',
        },
        premium: {
            name: 'Premium',
            price: 59.90,
            priceDisplay: 'R$ 59,90',
        },
    };

    const currentPlan = planDetails[pendingPlan] || planDetails.profissional;

    const handlePayment = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // Obter o userId do usuário autenticado
            const userId = user?.uid;

            if (!userId) {
                throw new Error('Usuário não autenticado');
            }

            // Criar preferência de pagamento no backend usando o plano pendente
            const response = await PaymentsAPI.createPreference(
                pendingPlan,
                userId
            );

            console.log('Resposta da API:', response);

            // Redirecionar para checkout do Mercado Pago
            // Em desenvolvimento, use sandboxInitPoint
            // Em produção, use initPoint
            const checkoutUrl = process.env.NODE_ENV === 'development'
                ? response.data.sandboxInitPoint
                : response.data.initPoint;

            if (!checkoutUrl) {
                throw new Error('URL de checkout não recebida');
            }

            // Redirecionar para o Mercado Pago
            window.location.href = checkoutUrl;

        } catch (error) {
            console.error('Erro ao processar pagamento:', error);
            alert(`Erro ao processar pagamento: ${error.message || 'Erro desconhecido'}`);
        } finally {
            setLoading(false);
        }
    };

    const handleCancelPlan = async () => {
        try {
            // Downgrade para plano básico
            await updateUserPlan('basico', 'active');
            navigate('/dashboard');
        } catch (error) {
            console.error('Erro ao cancelar:', error);
        }
    };

    return (
        <div className="payment-page">
            <div className="payment-container">
                <div className="payment-card">
                    <div className="payment-header">
                        <h1>Finalizar Assinatura</h1>
                        <p>Complete o pagamento para ativar seu plano {currentPlan.name}</p>
                    </div>

                    {/* Resumo do Plano */}
                    <div className="plan-summary">
                        <div className="summary-row">
                            <span>Plano Selecionado:</span>
                            <strong>{currentPlan.name}</strong>
                        </div>
                        <div className="summary-row">
                            <span>Valor Mensal:</span>
                            <strong>{currentPlan.priceDisplay}</strong>
                        </div>
                        <div className="summary-row">
                            <span>Tipo de Cobrança:</span>
                            <strong>Recorrente (mensal)</strong>
                        </div>
                    </div>

                    {/* Métodos de Pagamento */}
                    <form onSubmit={handlePayment} className="payment-form">
                        <h3>Escolha a forma de pagamento</h3>

                        <div className="payment-methods">
                            <label className={`payment-method-option ${paymentMethod === 'credit_card' ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    name="paymentMethod"
                                    value="credit_card"
                                    checked={paymentMethod === 'credit_card'}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                />
                                <div className="method-info">
                                    <i className="bi bi-credit-card"></i>
                                    <span>Cartão de Crédito</span>
                                </div>
                            </label>

                            <label className={`payment-method-option ${paymentMethod === 'pix' ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    name="paymentMethod"
                                    value="pix"
                                    checked={paymentMethod === 'pix'}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                />
                                <div className="method-info">
                                    <i className="bi bi-qr-code"></i>
                                    <span>PIX</span>
                                </div>
                            </label>

                            <label className={`payment-method-option ${paymentMethod === 'boleto' ? 'active' : ''}`}>
                                <input
                                    type="radio"
                                    name="paymentMethod"
                                    value="boleto"
                                    checked={paymentMethod === 'boleto'}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                />
                                <div className="method-info">
                                    <i className="bi bi-receipt"></i>
                                    <span>Boleto</span>
                                </div>
                            </label>
                        </div>

                        {/* Info sobre Mercado Pago */}
                        <div className="payment-info">
                            <i className="bi bi-shield-check"></i>
                            <div>
                                <strong>Pagamento seguro via Mercado Pago</strong>
                                <p>Seus dados estão protegidos. Você será redirecionado para o ambiente seguro do Mercado Pago.</p>
                            </div>
                        </div>

                        {/* Termos */}
                        <div className="payment-terms">
                            <p>
                                <i className="bi bi-info-circle"></i>
                                Ao confirmar, você concorda com a cobrança recorrente mensal de {currentPlan.priceDisplay}.
                                Você pode cancelar a qualquer momento.
                            </p>
                        </div>

                        {/* Botões */}
                        <div className="payment-actions">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Processando...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-lock-fill me-2"></i>
                                        Ir para Pagamento Seguro
                                    </>
                                )}
                            </button>

                            <button
                                type="button"
                                className="btn btn-outline"
                                onClick={handleCancelPlan}
                                disabled={loading}
                            >
                                Usar Plano Básico Grátis
                            </button>
                        </div>
                    </form>
                </div>

                {/* Info Sidebar */}
                <div className="payment-info-sidebar">
                    <h3>O que você ganha com {currentPlan.name}:</h3>
                    <ul className="benefits-list">
                        {pendingPlan === 'profissional' && (
                            <>
                                <li><i className="bi bi-check-circle-fill"></i> Produtos ilimitados</li>
                                <li><i className="bi bi-check-circle-fill"></i> Clientes ilimitados</li>
                                <li><i className="bi bi-check-circle-fill"></i> Gestão de pedidos</li>
                                <li><i className="bi bi-check-circle-fill"></i> Dashboard com gráficos</li>
                                <li><i className="bi bi-check-circle-fill"></i> Relatórios intermediários</li>
                                <li><i className="bi bi-check-circle-fill"></i> Exportação de dados</li>
                                <li><i className="bi bi-check-circle-fill"></i> Suporte prioritário</li>
                            </>
                        )}
                        {pendingPlan === 'premium' && (
                            <>
                                <li><i className="bi bi-check-circle-fill"></i> Tudo do Profissional</li>
                                <li><i className="bi bi-check-circle-fill"></i> Relatórios completos e avançados</li>
                                <li><i className="bi bi-check-circle-fill"></i> Análise de lucratividade</li>
                                <li><i className="bi bi-check-circle-fill"></i> Gráficos avançados</li>
                                <li><i className="bi bi-check-circle-fill"></i> Exportação completa</li>
                                <li><i className="bi bi-check-circle-fill"></i> Suporte VIP (24h)</li>
                                <li><i className="bi bi-check-circle-fill"></i> Treinamento personalizado</li>
                            </>
                        )}
                    </ul>

                    <div className="money-back">
                        <i className="bi bi-arrow-counterclockwise"></i>
                        <div>
                            <strong>Garantia de Satisfação</strong>
                            <p>Cancele quando quiser, sem multas ou taxas extras.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaymentPage;
